import { CustomAxiosRequestConfig } from "@/interfaces/customAxiosRequestConfig";
import { useMutation } from "@tanstack/vue-query";
import axios from "axios";

const validatePreviousRequest = async (previousRequest: {
  previousRequest: number;
}) => {
  const { data } = await axios.post(
    `${import.meta.env.VITE_LEGACY_BOOKING_URL}/validate_previous_request.php`,
    {
      signature: "e5A9IjDRgN7emrooZ7F72rhXFlJVN5",
      previous_request: previousRequest.previousRequest,
    },
    { errorHandling: false } as CustomAxiosRequestConfig,
  );

  return data;
};

const useValidationPreviousRequest = () => {
  const validatePreviousRequestMutation = useMutation(
    (params: { previousRequest: number }) =>
      validatePreviousRequest({
        previousRequest: params.previousRequest,
      }),
  );

  return {
    validatePreviousRequest: validatePreviousRequestMutation.mutate,
    validatePreviousRequestAsync: validatePreviousRequestMutation.mutateAsync,
    isLoading: validatePreviousRequestMutation.isLoading,
    isSuccess: validatePreviousRequestMutation.isSuccess,
    isError: validatePreviousRequestMutation.isError,
    error: validatePreviousRequestMutation.error,
  };
};

export default useValidationPreviousRequest;
